<!-- 邀请弹窗 -->
<template>
  <div>
    <vanPopup v-model="show" position="bottom">
        <div class="main">
          <div class="top">
            <div class="item left" @click="operation('copy')">
              <div class="item-icon">
                <svg
                  class="icon "
                  aria-hidden="true"
                >
                <use xlink:href="#icon71fuzhilianjie"></use>
                </svg>
              </div>
              <div class="text">
                复制链接
              </div>
            </div>
            <div class="right">
              <img :src="ShareImg" class="share"/>
              <div class="item" @click="operation('friends')">
                <div class="item-icon">
                  <svg
                    class="icon "
                    aria-hidden="true"
                  >
                  <use xlink:href="#icon72weixinhaoyou"></use>
                  </svg>
                </div>
                <div class="text">
                  微信好友
                </div>
              </div>
              <div class="item" @click="operation('wechatMoments')">
                <div class="item-icon">
                  <svg
                    class="icon "
                    aria-hidden="true"
                  >
                  <use xlink:href="#icon73pengyouquan"></use>
                  </svg>
                </div>
                <div class="text">
                  朋友圈
                </div>
              </div>
            </div>
          </div>
          <!-- 取消 -->
          <div class="btn" @click="close">{{ $t('app.label.cancel') }}</div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import ShareImg from '@/assets/images/share.png'
export default {
  name: 'invitation',
  data() {
    return {
      ShareImg,
      list: [
        {
          key: 'copy',
          name: '复制链接',
          icon: '#icon71fuzhilianjie'
        },
          {
          key: 'poster',
          name: '海报',
          icon: '#icon74haibao'
        },
        {
          key: 'Friends',
          name: '微信好友',
          icon: '#icon72weixinhaoyou'
        },
        {
          key: 'wechatMoments',
          name: '朋友圈',
          icon: '#icon73pengyouquan'
        }

      ],
      show: false
    }
  },
  methods: {
    // 点击操作处理函数
    operation(key) {
      if (key === 'copy') {
        const url = window.location.href
        const temp = document.createElement('input')
        temp.setAttribute('value', url)
        document.body.appendChild(temp)
        temp.select()
        document.execCommand('copy')
        this.$toast('复制成功')
        document.body.removeChild(temp)
      } else if (key === 'poster') {
        this.$parent.openQrCode()
      }
      this.show = false
    },
    openShow() {
      this.show = true
    },
    // 关闭窗口
    close() {
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.main{
  bottom: 0;
  left: 0;
  height:300px;
  background:rgba(255,255,255,1);
  border-radius:22px 22px 0px 0px;
  .top{
    display: flex;
    justify-content: space-evenly;
    padding: 47px 16px 0;
    .item {
      .item-icon {
        width:60px;
        height:60px;
        svg{
          width: 100%;
          height: 100%;
        }
      }
      .text {
        padding-top: 18px;
        height:20px;
        font-size:14px;
        font-weight:500;
        color:rgba(40,45,59,1);
        line-height:20px;
        text-align: center;
      }
    }
    .left{
      padding-top: 10px;
    }
    .right{
      box-sizing: border-box;
      position: relative;
      height: 120px;
      width: 175px;
      display: flex;
      justify-content: space-around;
      border:2px dashed rgba(192,197,217,1);
      padding-top: 10px;
    }
  }
  .btn {
    width:223px;
    height:50px;
    background:rgba(255,255,255,1);
    border-radius:25px;
    border:1px solid rgba(192,197,217,1);
    font-size:16px;
    color:rgba(86,95,118,1);
    line-height:50px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
}
.share {
  position: absolute;
  top: 0;
  left: 30px;
  transform: translateY(-100%);
  height: calc(100vh - 253px);
  width: auto;
}
/deep/.van-popup {
    overflow-y: visible;
    border-radius:22px 22px 0px 0px;
}
</style>
